import React from 'react'
import { Provider } from 'react-redux'
import { StoreContext } from 'sb-redux-hook'
import { ConnectedRouter } from 'sb-connected-react-router'
import GlobalsContext from 'sb-hooks/GlobalsContext'

import LanguageProvider from 'containers/LanguageProvider/LanguageProvider'


const Root = ({ children, store, storeEvents, globals, history, translationMessages }) => (
  <Provider store={store}>
    <StoreContext.Provider value={{ store, storeEvents }}>
      <GlobalsContext.Provider value={{ globals }}>
        <LanguageProvider messages={translationMessages}>
          <ConnectedRouter history={history}>
            {children}
          </ConnectedRouter>
        </LanguageProvider>
      </GlobalsContext.Provider>
    </StoreContext.Provider>
  </Provider>
)


export default Root
